<template>
  <section class="app-credit">
    <p>記者 / 陳玉梅</p>
    <p>攝影 / 鄒保祥  周永受  陳毅偉</p>
    <p>專題網頁製作 / HY Tan  Weiwei Hsu  陳姿廷  李又如  簡信昌</p>
  </section>
</template>
<script>
export default {
  name: 'AppCredit'
}
</script>
<style lang="scss" scoped>
.app-credit {
  width: 300px;
  margin: 0 auto;
  padding: 12px 0 15px;
  border-top: solid 1px #979797;
  @media (min-width: 768px) {
    width: 700px;
  }
  @media (min-width: 1024px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 900px;
  }
  p {
    color: rgba(0, 0, 0, 0.66);
    font-size: 13px;
    line-height: 1.8;
    letter-spacing: 1px;
    text-align: center;
    & + p {
      margin-top: 0;
      @media (min-width: 1024px) {
        margin-left: 3em;
      }
    }
  }
}
</style>
